var render = function render(){var _vm=this,_c=_vm._self._c;return _c('single-file-audio-player',{attrs:{"song":_vm.song}})
}
var staticRenderFns = []

export { render, staticRenderFns }